import {
  Grid,
} from "@material-ui/core";
import ContactTable from "./ContactTable";
import { Sidebar } from "../Sidebar";

export const ContactPage = () => {

  return (
    <>
      <div style={{ marginTop: 80, display: 'flex' }}>
        <Sidebar />
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <ContactTable />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
